export default __webpack_public_path__ + "static/PES3-bad20367994de654616c7d0a1658cdad.jpg";